import React, { useEffect, useState } from "react";

//CSS
import "./itemCardHeader.css";

//Components
import Button from "../Other Components/button";

//Animations
import { motion } from "framer-motion";
import { fadeIn } from "../Other Components/animations";
import useNarrowMode from "../../hooks/useNarrowModeChecker";

//Functions and hooks
import { useTranslation } from "react-i18next";

export default function ItemCardHeader({
  className = "item",
  propertiesToShow = [{ Value: "/", columnWidth: 1, Scrollable: false }],
  btnText,
  bBtnVisible = true,
  bBtnSectionVisible = true,
  btnSectionWidth = 1,
  onClick,
}) {
  const isNarrow = useNarrowMode();

  const { t } = useTranslation();

  const createColumns = () => {
    return propertiesToShow.map((item, index) => (
      <div key={index} className={className + " card-header-column"}>
        {t(item.Value) || "/"}
      </div>
    ));
  };

  const calculateGridColumns = () => {
    const contentColumns = propertiesToShow
      .map((item) => `${item.columnWidth}fr`)
      .join(" ");

    if (!bBtnSectionVisible) {
      return `${contentColumns} 0fr`;
    }

    const totalContentFr = propertiesToShow.reduce(
      (sum, item) => sum + item.columnWidth,
      0
    );

    const minButtonFr = totalContentFr * 0.15;
    const actualButtonFr = Math.max(btnSectionWidth, minButtonFr);

    return `${contentColumns} ${actualButtonFr}fr`;
  };

  const gridColumns = calculateGridColumns();

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={fadeIn(0.2)}
      className={className + " CardHeader"}
    >
      <div
        className={className + " CardHeaderDescContainer"}
        style={{
          gridTemplateColumns: gridColumns,
        }}
      >
        {createColumns()}
        {bBtnVisible && !isNarrow ? (
          <div className="card-header-column button-column">
            <Button
              onClick={onClick}
              btnStyle="btn-positive"
              btnMargin={"btn-small"}
              btnSize="btn-small"
              btnBehaviour="btn-fill"
              bNoShadow={true}
            >
              {t(btnText)}
            </Button>
          </div>
        ) : null}
      </div>
    </motion.div>
  );
}
